/**
 * System Settings Page Component
 *
 * Unified admin settings page with tabs for:
 * - LLM Providers: Manage LLM provider configurations
 * - Cache: Configure cache settings
 *
 * Requires global_admin role (superadmin only).
 */

import { useState, useEffect } from 'react';
import { PageLayout } from '../components/layouts';
import { LLMSettingsTab } from '../components/SystemSettings/LLMSettingsTab';
import { CacheSettingsTab } from '../components/SystemSettings/CacheSettingsTab';

const SYSTEM_SETTINGS_TAB_KEY = 'systemSettingsSelectedTab';

export function SystemSettingsPage() {
  // Load saved tab from localStorage on mount, default to 'llm'
  const [selectedTab, setSelectedTab] = useState<string>(() => {
    const savedTab = localStorage.getItem(SYSTEM_SETTINGS_TAB_KEY);
    return savedTab || 'llm';
  });

  // Save selected tab to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(SYSTEM_SETTINGS_TAB_KEY, selectedTab);
  }, [selectedTab]);

  return (
    <PageLayout
      title="System Settings"
      tabs={[
        { value: 'llm', label: 'LLM Providers' },
        { value: 'cache', label: 'Cache' },
      ]}
      selectedTab={selectedTab}
      onTabChange={setSelectedTab}
      testId="system-settings-page"
    >
      {selectedTab === 'llm' && <LLMSettingsTab />}
      {selectedTab === 'cache' && <CacheSettingsTab />}
    </PageLayout>
  );
}

export default SystemSettingsPage;
